"use client"

import { OneTagScript } from "@/components/pixel-scripts/one-tag-scripts/one-tag-script"
import { usePixelInjectionPermissionSisal } from "@/hooks/use-pixel-injection-permission"
import useSignupRequestStore from "@/store/signup-request-store"

export function OnetagSignupStartPixelScriptSisal() {
  const canInjectPixels = usePixelInjectionPermissionSisal()
  const { data } = useSignupRequestStore()

  if (!canInjectPixels) return null

  return (
    <OneTagScript
      segmentId="120397"
      scriptId="DT9-signup-start"
      netreferId={data.fromPdv ? "affiliation" : undefined}
    />
  )
}
